// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const HOME_SHOW_MORE_POSTS = "Zobraz dal\u0161\u00ed";
